export const flowActors = {
  Sistema: { color: "#1d4ed8", fill: "#eff6ff" },
  Concesión: { color: "#0f766e", fill: "#f0fdfa" },
  FinOps: { color: "#6d28d9", fill: "#f5f3ff" },
  Financiera: { color: "#92400e", fill: "#fffbeb" },
};

// Documentación funcional: estos diagramas no ejecutan operaciones ni cambian estados.
export const flowStages = [
  {
    id: "generacion",
    title: "Generación y reporte",
    height: 1100,
    description:
      "La preconciliación se genera automáticamente. Los usuarios autorizados reportan cada peaje por separado, tanto para pago consolidado como por peaje.",
    note: "Pasos, valor y Excel obligatorios por peaje; observación opcional. Los peajes reportados quedan bloqueados.",
    nodes: [
      {
        id: "config",
        x: 310,
        y: 20,
        w: 300,
        h: 66,
        lines: ["Revisar configuración de peajes", "y horarios del día"],
        actor: "Sistema",
      },
      {
        id: "eligible",
        x: 320,
        y: 122,
        w: 280,
        h: 100,
        lines: ["¿Hay peajes para", "preliquidar hoy?"],
        kind: "decision",
      },
      {
        id: "wait",
        x: 20,
        y: 140,
        w: 220,
        h: 66,
        lines: ["Esperar la siguiente ejecución"],
        actor: "Sistema",
      },
      {
        id: "key",
        x: 310,
        y: 266,
        w: 300,
        h: 74,
        lines: ["Generar llave de preconciliación", "con las concesiones incluidas"],
        actor: "Sistema",
      },
      {
        id: "pre",
        x: 310,
        y: 376,
        w: 300,
        h: 44,
        lines: ["Preconciliación / Preliquidación"],
        kind: "state",
      },
      {
        id: "mail",
        x: 60,
        y: 468,
        w: 300,
        h: 66,
        lines: ["Enviar correo a cada concesión", "incluida en la llave"],
        actor: "Sistema",
      },
      {
        id: "batches",
        x: 540,
        y: 468,
        w: 300,
        h: 66,
        lines: ["Mostrar la llave en Lotes", "e Información de concesión"],
        actor: "Sistema",
      },
      {
        id: "login",
        x: 60,
        y: 570,
        w: 300,
        h: 100,
        lines: [
          "Concesiones: solo su concesión",
          "Admin, Coordinador FinOps",
          "y Usuario FinOps con acceso",
          "pueden registrar el reporte",
        ],
        actor: "Sistema",
      },
      {
        id: "batchDetails",
        x: 540,
        y: 570,
        w: 300,
        h: 86,
        lines: [
          "En Lotes: consultar por llave",
          "y concesión; registrar novedades",
          "solo mientras estén permitidas",
        ],
        actor: "FinOps",
      },
      {
        id: "report",
        x: 60,
        y: 710,
        w: 300,
        h: 86,
        lines: [
          "Elegir un peaje pendiente",
          "Ingresar pasos, valor y Excel",
          "Observación opcional",
        ],
        actor: "Concesión",
      },
      {
        id: "complete",
        x: 70,
        y: 836,
        w: 280,
        h: 100,
        lines: ["¿Pasos, valor y Excel", "del peaje completos?"],
        kind: "decision",
      },
      {
        id: "saved",
        x: 60,
        y: 980,
        w: 300,
        h: 86,
        lines: [
          "Guardar sin sobrescribir otros peajes",
          "Bloquear el peaje reportado",
          "Conservar su Excel individual",
        ],
        actor: "Sistema",
      },
      {
        id: "allReported",
        x: 540,
        y: 710,
        w: 280,
        h: 100,
        lines: ["¿Todos los peajes", "están reportados?"],
        kind: "decision",
      },
      {
        id: "partial",
        x: 540,
        y: 856,
        w: 300,
        h: 86,
        lines: [
          "Enviar steps y value_concil en cero",
          "Pendientes en more como null",
          "Continuar con otro peaje",
        ],
        actor: "Sistema",
      },
      {
        id: "total",
        x: 540,
        y: 980,
        w: 300,
        h: 86,
        lines: [
          "Enviar la suma de pasos y valores",
          "Procesar la validación de la concesión",
          "Continuar a liquidación y pago",
        ],
        actor: "Sistema",
      },
    ],
    edges: [
      {
        points: [
          [460, 86],
          [460, 122],
        ],
      },
      {
        points: [
          [320, 172],
          [240, 172],
        ],
        label: "No",
        labelAt: [280, 156],
      },
      {
        points: [
          [460, 222],
          [460, 266],
        ],
        label: "Sí",
        labelAt: [480, 248],
      },
      {
        points: [
          [460, 340],
          [460, 376],
        ],
      },
      {
        points: [
          [460, 420],
          [460, 444],
          [210, 444],
          [210, 468],
        ],
      },
      {
        points: [
          [460, 444],
          [690, 444],
          [690, 468],
        ],
      },
      {
        points: [
          [210, 534],
          [210, 570],
        ],
      },
      {
        points: [
          [690, 534],
          [690, 570],
        ],
      },
      {
        points: [
          [210, 670],
          [210, 710],
        ],
      },
      {
        points: [
          [210, 796],
          [210, 836],
        ],
      },
      {
        points: [
          [70, 886],
          [30, 886],
          [30, 753],
          [60, 753],
        ],
        label: "No",
        labelAt: [44, 870],
      },
      {
        points: [
          [210, 936],
          [210, 980],
        ],
        label: "Sí",
        labelAt: [230, 960],
      },
      {
        points: [
          [360, 1023],
          [450, 1023],
          [450, 760],
          [540, 760],
        ],
      },
      {
        points: [
          [680, 810],
          [680, 856],
        ],
        label: "No",
        labelAt: [701, 839],
      },
      {
        points: [
          [820, 760],
          [890, 760],
          [890, 960],
          [690, 960],
          [690, 980],
        ],
        label: "Sí",
        labelAt: [863, 746],
      },
      {
        points: [
          [840, 899],
          [870, 899],
          [870, 690],
          [210, 690],
          [210, 710],
        ],
      },
    ],
  },
  {
    id: "pago",
    note: "El cuadre corresponde al peaje; el status corresponde a la concesión. El lote pasa a Pagado cuando todas sus concesiones están pagadas.",
    title: "Liquidación y pago",
    height: 1070,
    description:
      "La validación abre dos caminos: autoliquidación o valor confirmado por FinOps. Financiera descarga los pagos habilitados y adjunta el comprobante por llave y concesión.",
    nodes: [
      {
        id: "pre",
        x: 310,
        y: 20,
        w: 300,
        h: 44,
        kind: "state",
        lines: ["Reporte de la concesión recibido"],
      },
      {
        id: "rules",
        x: 320,
        y: 110,
        w: 280,
        h: 100,
        kind: "decision",
        lines: ["¿Los valores cuadran", "y cumplen las reglas?"],
      },
      {
        id: "ready",
        x: 40,
        y: 266,
        w: 300,
        h: 44,
        kind: "state",
        lines: ["Concesión: Autoliquidado"],
      },
      {
        id: "failed",
        x: 540,
        y: 252,
        w: 300,
        h: 74,
        actor: "Sistema",
        kind: "exception",
        lines: [
          "La concesión reportó valores distintos",
          "Concesión: En conciliación",
          "FinOps revisa las diferencias",
        ],
      },
      {
        id: "excel",
        x: 40,
        y: 376,
        w: 300,
        h: 86,
        actor: "Sistema",
        lines: [
          "Valor final de pago disponible",
          "Conservar el importe autorizado",
          "Bloquear nuevas novedades",
        ],
      },
      {
        id: "manual",
        x: 540,
        y: 376,
        w: 300,
        h: 74,
        actor: "FinOps",
        lines: [
          "Conciliar según el tipo de pago",
          "Valor por concesión o por peaje",
          "Confirmar el envío a Financiera",
        ],
      },
      {
        id: "amount",
        x: 540,
        y: 492,
        w: 300,
        h: 74,
        actor: "Sistema",
        lines: [
          "Concesión: Conciliado · Por liquidar",
          "Visible en Financiera con value_final",
          "Bloquear Conciliar y nuevas novedades",
        ],
      },
      {
        id: "check",
        x: 310,
        y: 626,
        w: 300,
        h: 74,
        actor: "Financiera",
        lines: [
          "Lotes financiera: descargar Excel de pago",
          "Solo auto_liquidado y conciliado-liquidar",
          "Archivo generado por el servidor",
        ],
      },
      {
        id: "pay",
        x: 310,
        y: 744,
        w: 300,
        h: 74,
        actor: "Financiera",
        lines: [
          "Pagar el value_final autorizado",
          "Cargar el documento del pago",
          "PDF o imagen (máx. 50 MB por archivo)",
        ],
      },
      { id: "paid", x: 310, y: 864, w: 300, h: 44, kind: "state", lines: ["Concesión: Pagado"] },
      {
        id: "proof",
        x: 20,
        y: 862,
        w: 260,
        h: 82,
        actor: "Sistema",
        lines: ["Comprobante visible en Lotes,", "Lotes financiera", "e Información de concesión"],
      },
      {
        id: "allPaid",
        x: 620,
        y: 850,
        w: 260,
        h: 100,
        kind: "decision",
        lines: ["¿Todas las concesiones", "del lote están pagadas?"],
      },
      {
        id: "batchPending",
        x: 200,
        y: 1008,
        w: 300,
        h: 44,
        kind: "state",
        lines: ["Lote: En proceso"],
      },
      {
        id: "batchPaid",
        x: 540,
        y: 1008,
        w: 300,
        h: 44,
        kind: "state",
        lines: ["Lote: Pagado"],
      },
    ],
    edges: [
      {
        points: [
          [460, 64],
          [460, 110],
        ],
      },
      {
        points: [
          [320, 160],
          [190, 160],
          [190, 266],
        ],
        label: "Sí",
        labelAt: [253, 146],
      },
      {
        points: [
          [600, 160],
          [690, 160],
          [690, 252],
        ],
        label: "No",
        labelAt: [645, 146],
      },
      {
        points: [
          [190, 310],
          [190, 376],
        ],
      },
      {
        points: [
          [690, 326],
          [690, 376],
        ],
      },
      {
        points: [
          [690, 450],
          [690, 492],
        ],
      },
      {
        points: [
          [190, 462],
          [190, 596],
          [460, 596],
          [460, 626],
        ],
      },
      {
        points: [
          [690, 566],
          [690, 596],
          [460, 596],
          [460, 626],
        ],
      },
      {
        points: [
          [460, 700],
          [460, 744],
        ],
      },
      {
        points: [
          [460, 818],
          [460, 864],
        ],
      },
      {
        points: [
          [310, 886],
          [290, 886],
          [290, 903],
          [280, 903],
        ],
      },
      {
        points: [
          [610, 886],
          [615, 886],
          [615, 830],
          [750, 830],
          [750, 850],
        ],
      },
      {
        points: [
          [750, 950],
          [750, 980],
          [690, 980],
          [690, 1008],
        ],
        label: "Sí",
        labelAt: [770, 974],
      },
      {
        points: [
          [620, 900],
          [600, 900],
          [600, 968],
          [350, 968],
          [350, 1008],
        ],
        label: "No",
        labelAt: [475, 956],
      },
    ],
  },
  {
    id: "conciliacion",
    note: "La revisión posterior no habilita nuevas novedades en Lotes para estados bloqueados.",
    title: "Conciliación posterior",
    height: 800,
    description:
      "FinOps revisa en Gestión de conciliaciones los días elegidos, contrasta los pagos con los reportes y registra observaciones. Pagado conserva el bloqueo de novedades en Lotes.",
    nodes: [
      { id: "paid", x: 310, y: 20, w: 300, h: 44, kind: "state", lines: ["Concesión: Pagado"] },
      {
        id: "filter",
        x: 310,
        y: 112,
        w: 300,
        h: 86,
        actor: "FinOps",
        lines: [
          "Ingresar a Gestión de conciliaciones",
          "Filtrar concesión, peaje",
          "y los días que se quieren revisar",
        ],
      },
      {
        id: "export",
        x: 20,
        y: 118,
        w: 220,
        h: 74,
        actor: "FinOps",
        lines: ["Descargar Excel con los datos", "de la vista y sus filtros"],
      },
      {
        id: "compare",
        x: 310,
        y: 252,
        w: 300,
        h: 86,
        actor: "FinOps",
        lines: [
          "Comparar Gopass, valores reportados",
          "por la concesión, novedades",
          "y pagos realizados",
        ],
      },
      {
        id: "differences",
        x: 320,
        y: 390,
        w: 280,
        h: 100,
        kind: "decision",
        lines: ["¿Existen diferencias?"],
      },
      {
        id: "finish",
        x: 40,
        y: 558,
        w: 300,
        h: 54,
        kind: "end",
        lines: ["Finalizar revisión de conciliación"],
      },
      {
        id: "talk",
        x: 540,
        y: 550,
        w: 300,
        h: 74,
        actor: "FinOps",
        lines: ["Comunicarse con la concesión", "y revisar los soportes"],
      },
      {
        id: "review",
        x: 540,
        y: 688,
        w: 300,
        h: 74,
        actor: "FinOps",
        lines: [
          "Registrar observaciones por fila",
          "Revisar diferencias con la concesión",
          "sin agregar novedades a un lote pagado",
        ],
      },
    ],
    edges: [
      {
        points: [
          [460, 64],
          [460, 112],
        ],
      },
      {
        points: [
          [310, 155],
          [240, 155],
        ],
      },
      {
        points: [
          [460, 198],
          [460, 252],
        ],
      },
      {
        points: [
          [460, 338],
          [460, 390],
        ],
      },
      {
        points: [
          [320, 440],
          [190, 440],
          [190, 558],
        ],
        label: "No",
        labelAt: [250, 425],
      },
      {
        points: [
          [600, 440],
          [690, 440],
          [690, 550],
        ],
        label: "Sí",
        labelAt: [645, 425],
      },
      {
        points: [
          [690, 624],
          [690, 688],
        ],
      },
      {
        points: [
          [840, 725],
          [875, 725],
          [875, 295],
          [610, 295],
        ],
      },
    ],
  },
];
